import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-977613fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactform" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "contactform__button_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FormKit, {
      type: "form",
      modelValue: _ctx.formdata,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formdata) = $event)),
      onSubmit: _ctx.sendToApi,
      id: _ctx.contactform,
      disabled: _ctx.submitted,
      actions: false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema, (field) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: field.id
          }, [
            (
            field.type === 'text' ||
            field.type === 'textarea' ||
            field.type === 'email'
          )
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 0,
                  type: field.type,
                  label: field.label,
                  name: field.name,
                  placeholder: field.placeholder,
                  modelValue: _ctx.formdata[field.name],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.formdata[field.name]) = $event),
                  validation: "required",
                  classes: { outer: field.type === 'textarea' ? 'fullwidth' : '' }
                }, null, 8, ["type", "label", "name", "placeholder", "modelValue", "onUpdate:modelValue", "classes"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onSubmit", "id", "disabled"]),
    (_ctx.submitted)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [
          [_directive_sanitize, _ctx.notification]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ButtonLink, {
        onClick: _ctx.submitFromExternalButton,
        class: "contactform__button",
        label: "Verzenden",
        elementtype: "span",
        color: "yellow"
      }, null, 8, ["onClick"])
    ])
  ]))
}